import { FormattedMessage } from 'react-intl';

import DocumentImage, { DocumentImageProps } from './DocumentImage';
import Duration from './Duration';

export interface DocumentCardThumbnailProps extends Omit<
    DocumentImageProps,
    'type' | 'media' | 'ratio'
> {
    type?: DocumentTypeString | 'native_ad' | null;
    image?: DocumentImageProps['media'];
    coverImage?: DocumentImageProps['media'];
    ratio?: CardRatio | number | null;
    withCover?: boolean | null;
    duration?: number | null;
    withoutDuration?: boolean;
    withDurationInImage?: boolean;
    withAdNotice?: boolean;
    durationClassName?: string | null;
    adNoticeClassName?: string | null;
}

/**
 * Thumbnail of the document cards: the image (the cover of a vertical micromag), its icons, the
 * duration of a video or a podcast and the ad notice of a native ad.
 */
function DocumentCardThumbnail({
    type = null,
    image = null,
    coverImage = null,
    ratio = null,
    withCover = null,
    duration = null,
    withoutDuration = false,
    withDurationInImage = false,
    withAdNotice = false,
    durationClassName = null,
    adNoticeClassName = null,
    ...props
}: DocumentCardThumbnailProps) {
    const finalWithCover =
        withCover !== null
            ? withCover
            : type === 'micromag' && (ratio === 'vertical' || ratio === 'micromag');
    const showDuration =
        duration !== null &&
        duration > 0 &&
        (type === 'video' || type === 'podcast') &&
        !withoutDuration;
    const durationElement = showDuration ? (
        <Duration duration={duration} timestamp={type === 'video'} className={durationClassName} />
    ) : null;
    return (
        <>
            <DocumentImage
                {...props}
                type={type as DocumentTypeString | null}
                media={finalWithCover ? coverImage || image : image}
            >
                {withDurationInImage ? durationElement : null}
            </DocumentImage>
            {!withDurationInImage ? durationElement : null}
            {withAdNotice ? (
                <div className={adNoticeClassName}>
                    <FormattedMessage defaultMessage="Publicité" description="Card label" />
                </div>
            ) : null}
        </>
    );
}

export default DocumentCardThumbnail;
